import React from 'react';

import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { KnzComponentProps } from '../../types';

/**
 * チェックリスト（WorkflowChecklist ベース）。
 * params: title（任意, グループ見出し）、text（array, チェック項目）
 */
export const Checklist: React.FC<KnzComponentProps> = ({ node, renderInline }) => {
  const title = node.params.title as string | undefined;
  const rawItems = node.params.text;
  const items: string[] = Array.isArray(rawItems) ? rawItems : rawItems ? [String(rawItems)] : [];

  return (
    <Box sx={{ border: 1, borderColor: 'divider', borderRadius: 2, p: 2 }}>
      {title && (
        <Typography variant="body2" fontWeight={600} sx={{ mb: 1.5 }}>
          {title}
        </Typography>
      )}
      <Stack spacing={0.75}>
        {items.map((item, i) => (
          <Stack key={i} direction="row" alignItems="flex-start" spacing={1}>
            <CheckBoxOutlineBlankIcon
              sx={{ fontSize: 18, color: 'text.disabled', mt: 0.2, flexShrink: 0 }}
            />
            <Typography variant="body2" color="text.secondary" component="div">
              {renderInline(item)}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </Box>
  );
};

export default Checklist;
